import { Directive, inject } from '@angular/core';
import { BrnPopover } from '@spartan-ng/brain/popover';

@Directive({
  selector: '[hlmPopover],hlm-popover',
  exportAs: 'hlmPopover',
  hostDirectives: [
    {
      directive: BrnPopover,
      inputs: [
        'align',
        'attachTo',
        'autoFocus',
        'closeOnOutsidePointerEvents',
        'offsetX',
        'sideOffset',
        'state',
      ],
      outputs: ['stateChanged', 'closed'],
    },
  ],
  host: { 'data-slot': 'popover', class: 'ocp-spartan-scope inline-flex items-center' },
})
export class HlmPopover {
  private readonly _brnPopover = inject(BrnPopover);

  public open(): void {
    this._brnPopover.open();
  }

  public close(): void {
    this._brnPopover.close();
  }

  public toggle(): void {
    this._brnPopover.toggle();
  }
}
